/*@ngInject*/
const PolicyCancellationActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadPolicyCancellationActions = function (policyCancellationId) {
        var url = '/rest/Actions?uri=com.firstbest.underwriting.policy.cancellation.PolicyCancellation:' + policyCancellationId + '&registrationIdentifier=/PolicyCancellation/' + policyCancellationId,
            cacheKey = 'policyCancellationActions:' + policyCancellationId;

        if (currentSubmissionModel.hasActionsRegistration('/PolicyCancellation/' + policyCancellationId)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration('/PolicyCancellation/' + policyCancellationId, url);
                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('policyCancellationActionsRepository', PolicyCancellationActionsRepository);
